import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import { IUser } from '../../../model/user'
import { IComment } from '../../../model/comment'
import commentStore from '../../comment/comment-store'
import authStore from '../../auth/auth-store'

export default async function fetchAllJybedForUser(context: BareActionContext<ConvoState, RootState>, payload: { convo: IConvo, comment: IComment }) {
  const convo = payload.convo
  const comment = payload.comment
  if (convo.meta && convo.id && comment.meta) {
    const user = comment.meta.creator
    if (comment.meta.creator.id === (authStore.user as IUser).id) {
      console.log('fetchAllJybedForUser: is user, setting from convo: %j', comment)
      commentStore.commitSetIsAllJybed({ comment: comment, isAllJybed: convo.meta.isAllJybed })
    } else if (user.meta && user.meta.convoMap.has(convo.id)) {
      console.log('fetchAllJybedForUser: is in map: %j', comment)
      commentStore.commitSetIsAllJybed({ comment: comment, isAllJybed: user.meta.convoMap.get(convo.id) as boolean })
    } else if(user.id) {
      console.log('fetchAllJybedForUser: fetching from db: %j', comment)
      convoUtils.convoService.getIsJybedForUser(convo, user).then((isAllJybedMeta: Meta<boolean>) => {
        if (user.meta) user.meta.convoMap.set(convo.id as number, isAllJybedMeta.value)
        commentStore.commitSetIsAllJybed({ comment: comment, isAllJybed: isAllJybedMeta.value })
      })
    }
  }

  return
}
